import { Layout, theme } from "antd";
import { Content } from "antd/es/layout/layout";
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../components/layout/sidebar";
import Topbar from "../components/layout/topbar";
import CancelModal from "../components/modal/cancelModal";
import useCancelModal from "../lib/hooks/useCancelModal";
import backgroundImage from "../assets/images/dashbaord/background.png";

const WithSidebar = ({ defaultBg = "", children }) => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const navigate = useNavigate();
  const location = useLocation();
  const { openCancelModal, setOpenCancelModal, previousPage } =
    useCancelModal();

  return (
    <Layout
      style={{
        minHeight: "100vh",
      }}
    >
      <Topbar colorBgContainer={colorBgContainer} />

      <Layout>
        <Sidebar />
        <Content
          style={{
            padding: 15,
            backgroundImage:
              defaultBg === "" &&
              location.pathname === "/" &&
              `linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)), url(${backgroundImage})`,
            backgroundSize:
              defaultBg === "" && location.pathname === "/" && `cover`,
          }}
        >
          {children}
        </Content>

        <CancelModal
          title={`ยกเลิกการเปลี่ยนแปลง`}
          subTitle={`การเปลี่ยนแปลงจะไม่ถูกบันทึก คุณต้องการยืนยันดำเนินการต่อหรือไม่ ?`}
          onCancel={() => {
            setOpenCancelModal(false);
          }}
          onOk={() => {
            if (previousPage) {
              navigate(previousPage);
            } else {
              navigate(-1);
            }
            setOpenCancelModal(false);
          }}
          open={openCancelModal}
          confirmTxtBtn="ยืนยัน"
        />
      </Layout>
    </Layout>
  );
};

export default WithSidebar;
